
    import axios from 'axios'
    import store from '../store/index.js'

    export default {
        async add_comment_votes(params)  {
            return await axios.post('comment_votes/create.php' , params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async get_comment_votes()  {
            // return await axios.get('comment_votes/read.php')
            // .then(r =>{
            //     return r
            // })
            // .catch(e =>{
            //     console.log(e);
            // })
            store.commit('get_comment_votes')
        },
        async delete_comment_votes(comment_vote_id)  {
            return await axios.post('comment_votes/delete.php' , {
                comment_vote_id : comment_vote_id
            })
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async getOne(comment_vote_id)  {
            return await axios.post('comment_votes/readOne.php' , {
                comment_vote_id : comment_vote_id
            })
            .then(r =>{
                return r
                
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async update_comment_votes(params)  {
            return await axios.post('comment_votes/update.php' , params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async report_comment_votes(params)  {
            return await axios.post('comment_votes/report.php',params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
    }
